import React from 'react';
import moment from 'moment';
import { BooleanInput, FormDataConsumer, NumberInput, required } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { CustomDateTimeInput } from '../../../../commonComponents/CustomDateTimeInput';

const DATE_TIME_FORMAT = 'YYYY.MM.DD. HH:mm';
const MIN_VOUCHERS = 1;
const MAX_VOUCHERS = 999;

const vouchersPerPersonRange = (value) => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  return Number.isInteger(Number(value)) && value >= MIN_VOUCHERS && value <= MAX_VOUCHERS
    ? undefined
    : `Range must be between ${MIN_VOUCHERS}-${MAX_VOUCHERS}.`;
};

const validToAfterValidFrom = (value, { valid_from }) =>
  value && valid_from && !moment(value).isAfter(moment(valid_from))
    ? 'End date must be after the start date.'
    : undefined;

const useStyles = makeStyles({
  vouchersPerPersonField: {
    width: 256,
  },
});

const toISOString = (value) => (value ? moment(value).toISOString() : null);

// Used as `transform` on Create/Edit: the date picker emits local "YYYY-MM-DD HH:mm" strings.
export const transformVoucherLimit = (data) => ({
  ...data,
  valid_from: data.voucher_limit_enabled ? toISOString(data.valid_from) : null,
  valid_to: data.voucher_limit_enabled ? toISOString(data.valid_to) : null,
});

const VoucherLimitInputs = () => {
  const classes = useStyles();

  return (
    <>
      <BooleanInput label="Voucher limit per person" source="voucher_limit_enabled" defaultValue={false} />
      <FormDataConsumer>
        {({ formData }) =>
          formData.voucher_limit_enabled ? (
            <>
              <CustomDateTimeInput
                label="Valid from"
                source="valid_from"
                dateFormat={DATE_TIME_FORMAT}
                validate={required()}
              />
              <br />
              <CustomDateTimeInput
                label="Valid to"
                source="valid_to"
                dateFormat={DATE_TIME_FORMAT}
                validate={[required(), validToAfterValidFrom]}
              />
              <br />
              <NumberInput
                label="Vouchers per person"
                source="max_vouchers_per_person"
                defaultValue={MIN_VOUCHERS}
                min={MIN_VOUCHERS}
                max={MAX_VOUCHERS}
                step={1}
                className={classes.vouchersPerPersonField}
                validate={[required(), vouchersPerPersonRange]}
              />
            </>
          ) : null
        }
      </FormDataConsumer>
    </>
  );
};

export default VoucherLimitInputs;
